import * as momentTz from 'moment-timezone';
import {BreachListData, BreachData} from "../models/breach-list-model";
import {IBreachDataService} from "../shared/services/breach-data-service-interface";
import {Injectable} from "@angular/core";
import "rxjs/add/operator/toPromise";
import { HttpClient } from '@angular/common/http';

// import {DatePipe} from "@angular/common";

@Injectable()
export class BreachListDataService implements IBreachDataService {

  constructor(private http: HttpClient) {
  }

  public getBreachData(params: any): Promise<BreachListData> {
    let queryParams = `?dateFrom=${params.dateFrom}&dateTo=${params.dateTo}`;
    if (params.venueId) {
      queryParams += `&venueId=${params.venueId}`;
    }
    return this.http.get(`/data/breaches${queryParams}`)
        .toPromise()
        .then((response: any) => {
          const server: BreachData [] = response.data;
          const result = this.ConvertServerToClient(server);
          return result;
        })
        .catch((e) => this.handleError(e));
  }

  public getBreachConfig(): Promise<any> {
    return this.http.get("/data/breaches/config")
        .toPromise()
        .then((response: any) => {
          return response.data;
        })
        .catch((e) => this.handleError(e));
  }

  public ConvertServerToClient(serverData: Array<BreachData>) {
    const result = new BreachListData();
    serverData.forEach((v) => {
      if (v) {
        const dateDetected = momentTz(v.dateDetected).tz('Australia/Sydney').format('DD MMM YYYY');
        const dateDetectedSimple = momentTz(v.dateDetected).tz('Australia/Sydney').format('YYYY-MM-DD');
        // const dateDetected = new DatePipe("en-US").transform(v.dateDetected, "dd MMM yyyy");
        const turnOverInDollars = v.turnOver / 100;
        const row = new BreachData(v.venueId, v.licenceId,
          v.licenceName, v.licenceType, v.isActive, v.breachType, dateDetected, dateDetectedSimple,
          v.breachedDevices, v.totalDevices, turnOverInDollars, v.gamesPlayed
        );
        result.tableData.allRows.push(row);
      } else {
        console.error(`No breach information found`);
        console.info(v);
      }
    });

    result.tableData.copyAllRows();
    return result;
  }

  private handleError(error: any): Promise<any> {
    console.error("An error occurred", error);
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// ./client/app/services/breaches-list-data-service.ts